module.exports = __webpack_public_path__ + "static/media/vc1.e6d951b7.png";